import classNames from "classnames";
import CircleCancelIcon from "@svg/search/circle-cancel";
import BackIcon from "@svg/search/back";
import SearchIcon from "@svg/header/search";
import { useIsMobile } from "@shared/hooks/useIsMobile";
import { RefObject } from "react";

interface Props {
  value: string;
  withIcon?: boolean;
  withCancelIcon?: boolean;
  withReturnIcon?: boolean;
  placeholder: string;
  inputRef: RefObject<HTMLInputElement | null> | null;

  onEnter?: (value: string) => void;
  onChange: (value: string) => void;
  onCancel: () => void;
  onFocus: () => void;
  onClickReturn?: () => void;

  inputProps: any;
}

export const SearchInputContent = ({
  value,
  withIcon,
  withCancelIcon,
  withReturnIcon,
  placeholder,
  inputRef,
  onEnter,
  onChange,
  onCancel,
  onFocus,
  onClickReturn,
  inputProps,
}: Props) => {
  const isMobile = useIsMobile(768);

  return (
    <div className="relative flex h-full w-full flex-wrap focus-within:text-fds-brand">
      {withCancelIcon && value.length !== 0 && (
        <div
          onClick={onCancel}
          className="absolute left-0 z-10 mt-4 cursor-pointer pl-1 text-center lg:pl-4"
        >
          <CircleCancelIcon />
        </div>
      )}

      {withIcon && (
        <SearchIcon
          onClick={() => onEnter?.(value)}
          width={isMobile ? 20 : 24}
          height={isMobile ? 20 : 24}
          className={classNames(
            "absolute md:right-3 right-2 top-1/2 z-10 -translate-y-1/2",
            { "cursor-pointer": value !== "" }
          )}
        />
      )}

      {withReturnIcon && (
        <div className="absolute right-0 z-10 mt-4 cursor-pointer">
          <BackIcon onClick={onClickReturn} />
        </div>
      )}

      <input
        {...inputProps}
        ref={inputRef}
        value={value}
        type="text"
        placeholder={placeholder}
        className={classNames(
          "relative w-full rounded-6 p-2 !pr-9 md:!pr-10 md:text-sm text-xs font-normal text-fds-primary placeholder-fds-placeholder leading-6 md:leading-7 outline-none",
          withReturnIcon
            ? "rounded-none border-b-2 border-b-zinc-300 !pr-11 text-base font-light"
            : "focus:ring-1 focus:ring-fds-brand border border-fds-disable bg-fds-on-inverse"
        )}
        tabIndex={-1}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onEnter?.(value);
            e.preventDefault();
          }
        }}
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus}
      />
    </div>
  );
};
